export default __webpack_public_path__ + "41d206a33733e73da342000d53542137.png";